import { Link } from "react-router-dom";
import { categories } from "@/mocks/titles";

const toneClasses = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-700",
  "bg-secondary-100 text-secondary-700",
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
      {categories.map((cat, i) => (
        <Link
          key={cat.type}
          to={`/category/${cat.type}`}
          className="group rounded-lg bg-background-100 border border-background-200 hover:border-primary-300 p-5 md:p-6 transition-colors flex items-start gap-4"
        >
          <span
            className={`w-12 h-12 md:w-14 md:h-14 shrink-0 rounded-lg flex items-center justify-center ${toneClasses[i % toneClasses.length]}`}
          >
            <i className={`${cat.icon} text-2xl`}></i>
          </span>
          <div className="min-w-0">
            <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 group-hover:text-primary-600 transition-colors flex items-center gap-1">
              {cat.label}
              <i className="ri-arrow-right-up-line text-primary-500 text-lg"></i>
            </h3>
            <p className="mt-1.5 text-xs md:text-sm text-foreground-600 leading-relaxed">
              {cat.desc}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}